import Checkbox from "@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox";
import styles from "./UserAcknowledgement.module.scss";
import TermsAndConditionsAccordion from "../__shared__/TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import { ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE } from "../../constants/constants";

type Props = {
  /**
   * A string represting terms and condition text
   */
  terms: string;
  /**
   * A boolean indicating if the terms and conditions link should be displayed
   */
  includeTsAndCsLink: boolean;
};

export function UserAcknowledgementUI({ terms, includeTsAndCsLink }: Props) {
  const sendEvent = (checked: boolean) => {
    const e = new CustomEvent(ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE, {
      detail: {
        userAcknowledgementChecked: checked,
      },
    });
    window.dispatchEvent(e);
  };

  return (
    <div
      className={styles["user-acknowledege-container"]}
      data-testid="user-acknowledgement-container"
      data-component="UserAcknowledgement"
    >
      <Checkbox
        name="user-acknowledege-checkbox"
        className={styles["user-acknowledege-checkbox"]}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          sendEvent(event.target.checked);
        }}
        label={"I understand that I cannot return or exchange this item."}
        autoComplete="off"
      />
      <TermsAndConditionsAccordion terms={terms} />
      {includeTsAndCsLink && (
        <a
          href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions/home-services"
          target="_blank"
          rel="noreferrer"
        >
          Terms and conditions
        </a>
      )}
    </div>
  );
}
